var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-6"},[_c('WeeklyActivity',{attrs:{"team":_vm.team}}),_c('v-divider'),_c('Activity',{attrs:{"team":_vm.team}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }